import React from 'react';

function ComparisonMatrix() {
  const rows = [
    {
      dimension: 'Class Size & Ratio',
      video: '✕ Unassisted self-study',
      bootcamp: '✕ 200–500 students per batch',
      gurukulam: '✓ Max 30 developers per cohort'
    },
    {
      dimension: 'Code Review Process',
      video: '✕ No reviews',
      bootcamp: '✕ Automated script grading',
      gurukulam: '✓ 1:1 GitHub PR reviews by faculty'
    },
    {
      dimension: 'Curriculum Projects',
      video: '✕ Toy Todo & Weather apps',
      bootcamp: '✕ Cloned template repositories',
      gurukulam: '✓ Production distributed engines'
    },
    {
      dimension: 'Technical Defense',
      video: '✕ None',
      bootcamp: '✕ Multiple choice quizzes',
      gurukulam: '✓ Live oral architecture defense'
    },
    {
      dimension: 'Depth of Study',
      video: '✕ Basic language syntax',
      bootcamp: '✕ Framework-only focus',
      gurukulam: '✓ Kernel internals, memory, concurrency'
    }
  ];

  return (
    <section className="matrix-section" id="comparison">
      <div className="container">
        <div className="section-header text-center">
          <div className="section-tag">
            <span className="badge-pill badge-pill-cyan">Direct Comparison</span>
          </div>
          <h2 className="section-title">How Durbhasi Gurukulam Compares</h2>
          <p className="section-desc">
            A transparent overview of how our apprenticeship approach contrasts with recorded video libraries and mass-enrollment bootcamps.
          </p>
        </div>

        <div className="comparison-table-wrapper">
          <table className="comparison-table">
            <thead>
              <tr>
                <th style={{ width: '32%' }}>Program Dimension</th>
                <th style={{ width: '22%' }}>Pre-Recorded Video Platforms</th>
                <th style={{ width: '22%' }}>Mass Online Bootcamps</th>
                <th className="col-highlight" style={{ width: '24%' }}>Durbhasi Gurukulam</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, idx) => (
                <tr key={idx}>
                  <td><strong>{row.dimension}</strong></td>
                  <td><span className="check-no">{row.video}</span></td>
                  <td><span className="check-no">{row.bootcamp}</span></td>
                  <td className="col-highlight"><span className="check-yes">{row.gurukulam}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}

export default ComparisonMatrix;
